import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

  title: string = translate('DIALOG.CONFIRMATION');
  message: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) { }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.message;
    this.confirmButtonText = this.data.confirmButtonText || this.confirmButtonText;
  }
}
